import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getRem } from "./../../core";
var ToastActions = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['withMultipleActions'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: flex-end;\n  margin-left: auto;\n  min-width: ", ";\n  padding-right: ", ";\n  touch-action: none;\n  ", "\n"])), getRem('100px'), function (_ref) {
  var theme = _ref.theme;
  return theme.size.spacing.medium.value;
}, function (_ref2) {
  var withMultipleActions = _ref2.withMultipleActions;
  return withMultipleActions && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      width: 100%;\n    "])));
});
ToastActions.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,

  /** If true sets the width to 100% */
  withMultipleActions: PropTypes.bool
};
ToastActions.defaultProps = {
  withMultipleActions: false
};
export { ToastActions };